import { FC } from 'react';

import { GiftCsMemoTarget } from '@shared/api/giftCsMemo/giftCsMemo.interface';
import { CsMemoModalBase, CsMemoModalBaseProps } from '@shared/components/csMemo';

import { giftCsMemoAdapter } from './giftCsMemoAdapter';

export type CsMemoModalProps = Omit<
  CsMemoModalBaseProps<GiftCsMemoTarget>,
  'adapter'
>;

/** 답례품 CS 메모장 — 공용 모달에 gift 어댑터를 물려둔 것 */
export const CsMemoModal: FC<CsMemoModalProps> = (props) => (
  <CsMemoModalBase {...props} adapter={giftCsMemoAdapter} />
);
